export class dbh_loading {

    private dbh_pnlLoading: JQuery<HTMLElement>;

    private createLoadingPanel(): JQuery<HTMLElement> {
        return $('<section id="dbh_pnlLoading"><div class="dbh_loadingScreenContentWrapper"><div class="dbh_loadingScreenContent"></div></div></section>');
    }

    public onLoading(targetID: string, parentID?: string): void {
        if (targetID != '') {
            try {
                var targetElement: any = $('#' + targetID + ':visible').get(0);
                this.dbh_pnlLoading = this.createLoadingPanel();

                this.dbh_pnlLoading.height(targetElement.offsetHeight);
                this.dbh_pnlLoading.width(targetElement.offsetWidth);
                this.dbh_pnlLoading.css("margin", targetElement.style.margin);
                this.dbh_pnlLoading.css("padding", targetElement.style.padding);

                if (parentID != null) {
                    var dbh_parent: any = document.getElementsByTagName(parentID)[0];
                    this.dbh_pnlLoading.css("top", (targetElement.offsetTop + dbh_parent.offsetTop + 5) + 42 + "px");
                    this.dbh_pnlLoading.css("left", (targetElement.offsetLeft + dbh_parent.offsetLeft) + "px");
                }
                else {
                    if (targetElement.offsetParent != undefined && targetElement.offsetParent) {
                        let ol = 0;
                        let ot = 0;
                        do {
                            ol += targetElement.offsetLeft;
                            ot += targetElement.offsetTop;
                        } while (targetElement = targetElement.offsetParent);
                        this.dbh_pnlLoading.css("top", (ot) + "px");
                        this.dbh_pnlLoading.css("left", (ol) + "px");
                    }
                    else {
                        this.dbh_pnlLoading.css("top", (targetElement.offsetTop) + "px");
                        this.dbh_pnlLoading.css("left", (targetElement.offsetLeft) + "px");
                    }
                }
                $("body").append(this.dbh_pnlLoading);
                $(this.dbh_pnlLoading).show();
            }
            catch (e) {
                console.log("onLoading: " + e.Message);
            }
        }
    }

    public onLoadingPopup(targetID: string): void {
        if (targetID != '') {
            try {
                var targetElement: any = $('#' + targetID + ':visible').get(0);
                this.dbh_pnlLoading = this.createLoadingPanel();

                this.dbh_pnlLoading.height(targetElement.offsetHeight);
                this.dbh_pnlLoading.width(targetElement.offsetWidth);

                this.dbh_pnlLoading.css("margin", targetElement.style.margin);
                this.dbh_pnlLoading.css("position", "fixed");

                if (targetElement.offsetParent != undefined && targetElement.offsetParent) {
                    let ol = 0;
                    let ot = 0;
                    do {
                        ol += targetElement.offsetLeft;
                        ot += targetElement.offsetTop;
                    } while (targetElement = targetElement.offsetParent);
                    this.dbh_pnlLoading.css("top", (ot) + "px");
                    this.dbh_pnlLoading.css("left", (ol) + "px");
                }
                else {
                    this.dbh_pnlLoading.css("top", (targetElement.offsetTop) + "px");
                    this.dbh_pnlLoading.css("left", (targetElement.offsetLeft) + "px");
                }

                $(this.dbh_pnlLoading).show();
            }
            catch (e) {
                console.log("onLoading: " + e.Message);
            }
        }
    }

    public onLoadingFinished(): void {
        $(this.dbh_pnlLoading).remove();
    }
}